<template>
<el-dialog title="添加商品" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" :append-to-body="true">
    <div class="dialog-body">
        <el-form ref="form" :model="ruleForm" label-width="100px">
            <el-form-item label="选择供应商">
                <el-select v-model="ruleForm.supplier_id" placeholder="请选择类型" filterable clearable @change="changeSupplier">
                    <el-option v-for="(item,index) in supplierList" :key="index" :label="item.title" :value="item.id+''"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选择商品" v-if="ruleForm.supplier_id > 0">
                <el-select v-model="ruleForm.product_id" placeholder="请选择类型" filterable clearable @change="chooseProduct">
                    <el-option v-for="(item,index) in productList" :key="index" :label="item.title" :value="item.id+''"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="其他金额" v-if="ruleForm.supplier_id > 0">
                <el-input type="number" style="width:200px" v-model="ruleForm.other_fee"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="textarea" style="width:200px" v-model="ruleForm.remark"></el-input>
            </el-form-item>
        </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
    </span>
</el-dialog>
</template>

<script>
const ruleForm = {
    id: "",
    supplier_id: "",
    product_id: "",
    other_fee: "",
    remark:""
};

export default {
    props: {
        parent: {}
    },
    data() {
        return {
            supplierList: [],
            productList: [],
            dialogVisible: false,
            ruleForm: Object.assign({}, ruleForm),
            product: {},
            parentId: 0,
        };
    },

    methods: {
        showDialog(options, id,row, order) {
            let _this = this;
            _this.ruleForm = Object.assign({}, ruleForm)
            _this.parentId = options;
            _this.ruleForm.id = id;
            _this.order = order;
            _this.ruleForm.remark = row.remark
            this.dialogVisible = true;
            // 获取分类列表
            let url = '/api/supplier.company/index';
            _this.$post(url, {
                category_parent_id: _this.parentId
            }).then(res => {
                let resData = res.data;
                _this.supplierList = resData.list;
                _this.ruleForm.supplier_id = '';
            });
        },
        changeSupplier(supplier_id) {
            let _this = this;
            _this.ruleForm.supplier_id = supplier_id;
            // 获取分类列表
            let url = '/api/supplier.product/picker';
            _this.$post(url, {
                supplier_id: supplier_id
            }).then(res => {
                let resData = res.data;
                _this.productList = resData.list;
                _this.ruleForm.product_id = '';
            });
        },
        chooseProduct(productId) {
            let product = this.productList.find(ele => ele.id == productId);
            if (product) {
                this.product = product;
            }
        },
        submit() {
            if (Object.keys(this.product).length == 0) {
                this.$message({
                    type: 'danger',
                    message: '请选择产品'
                });
                return false;
            }
            let _this = this;
            // 获取分类列表
            let url = '/api/wedding.four/allocate';
            _this.$post(url, {
                id: _this.order.id,
                supplier_id: _this.ruleForm.supplier_id,
                product_id: _this.ruleForm.product_id,
                other_fee: _this.ruleForm.other_fee,
                remark:_this.ruleForm.remark
            }).then(res => {
                if (res.code == '200') {
                    _this.parent.showDrawer(_this.order);
                    // _this.parent.getDate();
                    _this.parent.parent.getTableData();
                    _this.dialogVisible = false;
                    _this.$message({
                        type: 'success',
                        message: res.msg
                    });

                } else {
                    _this.$message({
                        type: 'danger',
                        message: res.msg
                    });
                }
            });

        }
    }
}
</script>
